import { Filters, IncludedCurrentFace } from './types';
import { getPresetById } from './presetUtils';

export const prepareIncludedCurrentFaces = (filters: Filters): IncludedCurrentFace[] => {
  const ids = filters.currentFaceRangeIds || [];

  if (ids.length > 0) {
    return ids.map((id) => {
      const preset = getPresetById(id);
      return {
        includedCurrentFaceFrom: preset?.currentFaceRangeFromValue ?? null,
        includedCurrentFaceTo: preset?.currentFaceRangeToValue ?? null,
      };
    });
  }

  const { min, max } = filters.currentFaceRange?.range || {};
  return [{ includedCurrentFaceFrom: min, includedCurrentFaceTo: max }];
};
